export default __webpack_public_path__ + "static/solitairering-2f9dbfbd1dffb25fa4755a155d8431ef.png";